module.exports = __webpack_public_path__ + "img/bg-image.bdc066f7.jpg";